import request from '@/utils/request'

export function getCommentTemplateList(params = {}) {
  return request.get('/heritage/admin/comment-template', params)
}

export function getCommentTemplateDetail(id) {
  return request.get('/heritage/admin/comment-template/detail', { id })
}

export function saveCommentTemplate(data) {
  return request.post('/heritage/admin/comment-template/save', data)
}

export function deleteCommentTemplate(id) {
  return request.post('/heritage/admin/comment-template/delete', { id })
}
